import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on home page or auth page
  if (location.pathname === '/' || location.pathname === '/auth') {
    return null;
  }

  // Route name mapping
  const routeNames: { [key: string]: string } = {
    'score': 'Loaded Score',
    'artifacts': 'Career Artifacts',
    'big-sheet': 'Big Sheet',
    'opportunity-audit': 'Opportunity Audit',
    'power-moves': 'Power Moves',
    'okrs': 'OKRs',
    'create': 'Create',
    'rate-whisperer': 'Rate Whisperer',
    'dashboard': 'Dashboard',
    'workspace': 'AI Assistants',
    'assessment': 'Assessment',
    'product-management': 'Product Management'
  };

  const getBreadcrumbName = (pathname: string) => {
    return routeNames[pathname] || pathname.charAt(0).toUpperCase() + pathname.slice(1);
  };

  return (
    <div className="container-content py-3 border-b border-border/30">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/" className="flex items-center gap-1 text-text-muted hover:text-primary transition-colors">
                <Home className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">Home</span>
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          
          {pathnames.map((pathname, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            
            return (
              <React.Fragment key={`breadcrumb-${pathname}-${index}`}>
                <BreadcrumbSeparator>
                  <ChevronRight className="h-3.5 w-3.5" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  {isLast ? (
                    <BreadcrumbPage className="text-text-primary font-medium">
                      {getBreadcrumbName(pathname)}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link 
                        to={routeTo}
                        className="text-text-muted hover:text-primary transition-colors"
                      >
                        {getBreadcrumbName(pathname)}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </React.Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;